// extracted by mini-css-extract-plugin
export default {"address":"address-card_address__vyWd2"};